module.exports = __webpack_public_path__ + "static/dabanga-4-c8b3fcea369a9e55d49f9c9f089dfc54.png";